// @ts-nocheck
import { IPSLSel } from "src/views/OptionsView/PSL/PslSelect";

export const isDefinedPSLSelection = (val: IPSLSel | undefined): boolean => {
  return (
    val !== undefined &&
    val.modelyear !== undefined &&
    val.typefamily !== undefined &&
    val.cnr !== undefined
  );
};

export enum VIEWNAME {
  DERIVATEVIEW = 0,
  OPTIONVIEW = 1,
  BASICOPTIONVIEW = 2,
  KUMAVIEW = 3,
}

export const stringToColor = (value: string) => {
  let hash = 0;
  let i;

  /* tslint:disable-next-line:no-bitwise */
  for (i = 0; i < value.length; i += 1) {
    /* tslint:disable-next-line:no-bitwise */
    hash = value.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    /* tslint:disable-next-line:no-bitwise */
    const updatedvalue = (hash >> (i * 8)) & 0xff;
    /* tslint:disable-next-line:no-bitwise */
    color += `00${updatedvalue.toString(16)}`.slice(-2);
  }
  return color;
};
export const stringAvatar = (name: string) => {
  return {
    children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`,
  };
};



// WEBPACK FOOTER //
// ./src/utils/GeneralUtils.ts